import { render } from "./licenceFormModal.vue?vue&type=template&id=60ac1e7c&ts=true"
import script from "./licenceFormModal.vue?vue&type=script&lang=ts"
export * from "./licenceFormModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__